import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

/**
 * Reverse-trial ServCo tenants should see the STAR modal without being
 * enrolled into the STAR experiment itself.
 */
export function isEligibleForExploreEditionBenefitsModalReverseTrial({
	product,
	edition,
	isInReverseTrial,
	lastKnownTrial,
}: EditionAwarenessContextType): boolean {
	return Boolean(
		edition === 'standard' &&
		isInReverseTrial &&
		isProductOneOf(product, ['jira-service-management', 'jira-customer-service']) &&
		lastKnownTrial?.trialTrigger === 'CROSSFLOW_REVERSE_TRIAL' &&
		fg('jsmgrowth-369-reverse-trials-ea-kill-switch'),
	);
}
